import { MapPin } from "lucide-react";

export default function AboutImageCard({ locationCaption }) {
  return (
    <div className="relative rounded-3xl overflow-hidden aspect-[4/3]">
      <img
        src="https://images.unsplash.com/photo-1694544067801-f1c60ca9972d?crop=entropy&cs=srgb&fm=webp&q=75&w=900&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxsYWtlJTIwYmFsYXRvbiUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3ODIwMjk3OTJ8MA&ixlib=rb-4.1.0"
        alt="Lake Balaton landscape"
        width="900"
        height="675"
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover"
      />
      <div className="absolute -bottom-4 -right-4 sm:bottom-6 sm:right-6 card-surface px-5 py-4 max-w-[200px]">
        <MapPin className="w-5 h-5 text-[var(--accent)] mb-1" />
        <div className="font-bold text-sm">Balatonszemes</div>
        <div className="text-xs text-[var(--muted)]">{locationCaption}</div>
      </div>
    </div>
  );
}
